export enum PortalTypes {
  MEMBER = "member",
  PROVIDER = "provider",
  CLINICAL = "clinic",
  ADMIN = "admin",
  PARTNER= "partner"
}
